import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';
// Configurar axios con cookies HTTP-only
import '@/shared/utils/axios-config';
import { setupServiceWorkerListeners } from '@/shared/pwa/registerServiceWorker';

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Configurar listeners para eventos del Service Worker
// El registro automático lo hace vite-plugin-pwa
setupServiceWorkerListeners();
